import React from "react";
import CodeMirror from "@uiw/react-codemirror";
import { javascript } from "@codemirror/lang-javascript";
import { EditorView, keymap } from "@codemirror/view";
import { EditorState } from "@codemirror/state";
import { search, searchKeymap } from "@codemirror/search";
import { LANGUAGES, DEFAULT_HEIGHT, DEFAULT_OPTIONS, BASE_THEME } from "./HyroCodeEditor.consts";
import useCodeEditorCompletions from "./extensions/autocomplete/Autcomplete.hook";

const EMPTY_ARRAY = [];

const HyroCodeEditor = ({
  value = "",
  onChange,
  language = LANGUAGES.JSON,
  readOnly = false,
  placeholder = "",
  height = DEFAULT_HEIGHT,
  minHeight,
  maxHeight,
  error = false,
  helperText = "",
  editorOptions,
  completionSchema,
  extensions: additionalExtensions = EMPTY_ARRAY,
  ...props
}) => {
  const { javascriptAutocomplete } = useCodeEditorCompletions(completionSchema);

  const getLanguageExtension = () => {
    if (language === LANGUAGES.JSON) {
      return [javascript({ json: true })];
    }
    if (language === LANGUAGES.JAVASCRIPT) {
      return [javascript(), javascriptAutocomplete].filter(Boolean);
    }
    return [];
  };

  const extensions = [
    EditorView.theme(BASE_THEME),
    ...getLanguageExtension(),
    search({ top: true }),
    keymap.of(searchKeymap),
    ...(readOnly ? [EditorState.readOnly.of(true)] : []),
    ...additionalExtensions
  ];

  return (
    <>
      <CodeMirror
        value={value}
        onChange={onChange}
        extensions={extensions}
        placeholder={placeholder}
        height={height}
        basicSetup={{
          ...DEFAULT_OPTIONS,
          ...editorOptions
        }}
        {...props}
      />
    </>
  );
};

export default HyroCodeEditor;
